<template>
  <nav class="flex items-center justify-center" :class="compact ? 'mt-0 gap-1' : 'mt-4 gap-2'">
    <button
      type="button"
      class="border-0 rounded-md"
      :class="compact ? 'h-8 w-8 shrink-0 p-0 text-lg leading-none' : 'px-3 py-1'"
      :aria-label="$t('common.prev')"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
    >
      <span aria-hidden="true">{{ compact ? '‹' : '←' }}</span>
      <span v-if="compact" class="sr-only">{{ $t('common.prev') }}</span>
      <span v-else class="ml-1">{{ $t('common.prev') }}</span>
    </button>

    <button
      v-for="page in visiblePages"
      :key="page"
      type="button"
      class="border-0 rounded-md"
      :class="[compact ? 'h-8 w-8 shrink-0 p-0' : 'px-3 py-1', { 'bg-primary text-white': page === currentPage }]"
      :aria-current="page === currentPage ? 'page' : undefined"
      @click="changePage(page)"
    >
      {{ page }}
    </button>

    <button
      type="button"
      class="border-0 rounded-md"
      :class="compact ? 'h-8 w-8 shrink-0 p-0 text-lg leading-none' : 'px-3 py-1'"
      :aria-label="$t('common.next')"
      :disabled="currentPage === paginatorInfo.lastPage"
      @click="changePage(currentPage + 1)"
    >
      <span v-if="compact" aria-hidden="true">›</span>
      <span v-else>{{ $t('common.next') }} <span aria-hidden="true">→</span></span>
      <span v-if="compact" class="sr-only">{{ $t('common.next') }}</span>
    </button>
  </nav>
</template>

<script setup>
import { usePagination } from '@jinkosoft/pagination'

const props = defineProps({
  paginatorInfo: {
    type: Object,
    required: true
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['pageChange'])

const { currentPage, visiblePages, changePage } = usePagination(props, emit)
</script>
